import { render, staticRenderFns } from "./FeatureComingSoon.vue?vue&type=template&id=06f7cc62&"
import script from "./FeatureComingSoon.vue?vue&type=script&lang=ts&"
export * from "./FeatureComingSoon.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureComingSoon.vue?vue&type=style&index=0&id=06f7cc62&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports